export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9197.cc5eb249.jpg";